import { createPaymentRequestSchema } from "@/constants/zod-schemas";
import { useDisclosure } from "@/hooks";
import { useAddNewPayment } from "@/hooks/query-hooks/usePayments";
import { Button, Form, Modal } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { FormValues, PaymentForm } from "./PaymentForm";

export function AddNewPaymentModal() {

    const [opened, { toggle }] = useDisclosure(false);
    const [form] = Form.useForm();

    const { mutate, isMutating } = useAddNewPayment();
    const onSubmit = (data: FormValues) => {
        const { image } = data;
        const jsonData = createPaymentRequestSchema.parse(data)
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(jsonData)], { type: "application/json" }));
        formData.append("imageUrl", image?.file as unknown as File);
        mutate(formData, {
            onSuccess: () => {
                toggleModal();
                form.resetFields();
            }
        });
    };

    const toggleModal = () => {
        form.resetFields();
        toggle();
    }

    return (
        <div>
            <Button
                icon={<AiOutlinePlus />}
                onClick={toggleModal}
                type="primary"
                shape="circle"
                size="large"
                className="bg-primary-gradient"
            />

            <Modal
                open={opened}
                onCancel={toggleModal}
                title="Payment အသစ်ထည့်ရန်"
                centered
                okButtonProps={{
                    type: "primary",
                    htmlType: "submit",
                    form: "add-new-payment-form",
                    className: "bg-primary-gradient",
                    size: "large",
                    shape: "round",
                    loading: isMutating,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isMutating,
                }}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                maskClosable={!isMutating}
            >
                <PaymentForm
                    form={form}
                    onSubmit={onSubmit}
                    initialValues={{
                        accName: "",
                        accNo: "",
                        paymentType: "",
                        published: false,
                    }}
                    name="add-new-payment-form"
                    openedModal={opened}
                />
            </Modal>
        </div>
    )
}
